<template>
    <div>
        <v-container>
            <v-row style="padding:0px;">
                <v-col cols="12" style="padding-top:12px; padding-bottom:4px;">
                    <v-card elevation="2" outlined shaped>
                        <v-card-text style="padding:12px; margin-bottom:12px;">
                            <div>
                                <!-- LOADER -->
                                <div v-if="getIsLoadingAccountBalance && getAccountBalance.balance == null">
                                    <v-progress-circular
                                        :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                                        size="72" indeterminate></v-progress-circular>
                                </div>
                                <!-- BALANCE -->
                                <v-row>
                                    <v-col cols="6">
                                        <!-- Balance 32px for thousands 24px for 10,000.00 -->
                                        <div style="margin-bottom:5px;">
                                            <h1 v-if="getAccountBalance.balance != null"
                                                style="display:inline; font-size:24px;" 
                                                :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'">
                                                £{{
                                                        parseFloat(getAccountBalance.balance).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                                            ",")
                                                }}</h1>

                                            <h1 v-if="!getIsLoadingAccountBalance && getAccountBalance.balance == null"
                                                style="display:inline; font-size:24px;"
                                                :class="($vuetify.theme.dark) ? 'darkCounterBackground' : 'lightCounterBackground'">
                                                <v-icon style="display:inline-block;"
                                                    :color="($vuetify.theme.dark) ? 'var(--darkSecondColor)' : 'var(--lightSecondColor)'">
                                                    mdi-lock
                                                </v-icon>
                                            </h1>
                                        </div>
                                        <p class="pb-1" style="margin:0px; text-align: left; font-size: small;">Current
                                            balance</p>
                                    </v-col>
                                    <v-col cols="6">
                                        <div class="grid-container" style="">
                                            <div align="start">
                                                &nbsp;
                                                <p style="display:inline; margin: 0px; font-size: medium;">In-Today</p>
                                            </div>
                                            <div align="end">
                                                <h3 style="display:inline;"
                                                    :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'">£{{
                                                            parseFloat(todayIncome).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                                                ",")
                                                    }}</h3>
                                            </div>


                                            <div align="start">
                                                &nbsp;
                                                <p style="display:inline; margin: 0px; font-size: medium;">Pending</p>
                                            </div>
                                            <div align="end">
                                                <h3 style="display:inline;"
                                                    :class="($vuetify.theme.dark) ? 'darkPrime' : 'lightPrime'">
                                                    £{{
                                                            parseFloat(pendingPaymentsTotal).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                                                                ",")
                                                    }}
                                                </h3>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>



                                <v-divider style="padding-bottom:12px; padding-top:0px;"></v-divider>

                                <!-- ALERTS -->
                                <div>
                                    <v-row v-if="!getIsLoadingAccount">
                                        <v-col v-if="!hasIncompleteAcc" class="pb-0 pt-0">
                                            <!-- <v-alert v-if="getAccount != null && isNotificationsEnabled"
                                                v-on:click="navNotifications" class="alerts" dense text outlined
                                                :color="($vuetify.theme.dark) ? 'var(--darkSecondColor)' : 'var(--lightSecondColor)'"
                                                icon="mdi-bell">
                                                New Notifications <span class="counter2"
                                                    :class="($vuetify.theme.dark) ? 'darkCounterBackground' : 'lightCounterBackground'">{{
                                                            getAccount.id
                                                    }}</span>
                                            </v-alert> -->

                                            <v-alert class="alerts" v-if="lastTransactionDate.length > 0" outlined
                                                :color="($vuetify.theme.dark) ? 'var(--darkSecondColor)' : 'var(--lightSecondColor)'"
                                                icon="mdi-cash-multiple" dense text>
                                                Last transaction:
                                                {{ lastTransactionDate }}
                                            </v-alert>
                                            <v-alert class="alerts" v-if="lastTransactionDate.length < 1" outlined
                                                :color="($vuetify.theme.dark) ? 'var(--darkSecondColor)' : 'var(--lightSecondColor)'"
                                                icon="mdi-cash-multiple" dense text>
                                                Last transaction:
                                                NONE
                                            </v-alert>
                                        </v-col>
                                        <v-col v-if="hasIncompleteAcc" class="pb-0">
                                            <v-alert v-on:click="openNoPayDialog()"
                                                v-if="noPaymentDetailsMessage.length > 0" class="alerts" dense text
                                                outlined type="error" icon="mdi-bank-off">
                                                {{ noPaymentDetailsMessage }}
                                            </v-alert>
                                            <v-dialog :value="verificationDialog" width="550">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <slot name="activator" v-bind:on="on" v-bind:attrs="attrs">
                                                    </slot>
                                                </template>
                                                <v-card>
                                                    <v-card-title>Awaiting verification</v-card-title>
                                                    <v-card-text>
                                                        Before your account starts being used it must be verified by
                                                        someone in your organisation.
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-btn @click="closeVerificationDialog">
                                                            Close
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                    </v-card-actions>
                                                </v-card>

                                            </v-dialog>
                                            <v-alert v-if="noVerificationMessage.length > 0" class="alerts" dense text
                                                outlined
                                                :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                                                icon="mdi-account-lock">
                                                {{ noVerificationMessage }}
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" style="padding-bottom:0px;">
                    <v-divider></v-divider>
                    <div style="margin:0px;padding-top:12px;">
                        <b class="float-left"> Last 7 Days</b>

                        <v-btn :to="'/AllTransactions'" class="float-right"
                            :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'" rounded small dark>
                            View all
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col style="padding-bottom:0px; padding-top:0px;">
                    <v-tabs v-model="tabSelection"
                        :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" fixed-tabs>
                        <v-tab>In</v-tab>
                        <v-tab>PayOut</v-tab>
                        <v-tab>All</v-tab>
                    </v-tabs>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="isLoadingTransactions" align="center">
                    <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'"
                        size="72" indeterminate></v-progress-circular>
                </v-col>
                <v-col v-if="!isLoadingTransactions" :color="($vuetify.theme.dark) ? '#1E1E1E' : ''">
                    <!-- 475 - before adding nav-bottom -->
                    <transaction-line filterDate="false" :takenHeight="takenHeight" :filterType="tabSelection"
                        :allTransactions="transactions"></transaction-line>
                </v-col>
            </v-row>
            <v-row>
            </v-row>
            <v-bottom-navigation absolute horizontal v-if="isQuickLaunch">
                <v-item v-for="(launcher, index) in quickLaunch" :key="index">
                    <v-btn v-on:click="launcher.link">
                        <span v-if="getAccount != null && launcher.icon == 'mdi-bell'" class="counter"
                            :class="($vuetify.theme.dark) ? 'darkCounterBackground' : 'lightCounterBackground'">{{
                                    getAccount.id
                            }}</span>
                        <v-icon size="32" :color="($vuetify.theme.dark) ? 'white' : ''">{{
                                launcher.icon
                        }}</v-icon>
                    </v-btn>
                </v-item>
            </v-bottom-navigation>
        </v-container>
    </div>
</template>


<script>
import TransactionLine from "../components/TransactionLine.vue";
import { mapGetters, mapActions } from 'vuex';
import RestResource from '../RestResource.js';
import accessHelper from "@/mixins/accessHelper";
import promptHelper from "@/mixins/promptHelper";
const restResourceService = new RestResource();
export default {
    name: "PartnerHomePage",
    mixins: [accessHelper, promptHelper],
    components: {
        TransactionLine,
    },
    props: {
        drawer: Boolean,
    },
    data: () => ({
        takenHeight: '325',
        transactions: [],
        incoming: 0,
        outgoing: 0,
        totaloutandin: 0,
        incomingbar: 0,
        outgoingbar: 0,
        localdrawer: false,
        tabSelection: 0,
        todayIncome: 0,
        todayLastUpdated: "",
        todayLastSource: "",
        lastTransactionDate: "",
        hasIncompleteAcc: false,
        noPaymentDetailsMessage: "",
        noVerificationMessage: "",
        verificationDialog: false,
        isLoadingTransactions: false,
        pendingPaymentsTotal: 0,
        quickLaunch: [],
        isNotificationsEnabled: false,
        isQuickLaunch: false,
    }),
    computed: {
        ...mapGetters([
            'getAccount',
            'accountSettings',
            'getAccountBalance',
            'getIsLoadingAccountBalance',
            'getIsLoadingAccount',
            'installPrompt',
        ]),
    },
    mounted() {
        this.quickLanchSettingsEnabled();
    },
    watch: {
        getAccount: {
            //Handler just watches for deep mutations
            //Stops anything being called untill account api call finishes
            handler(account) {
                if (account != null) {
                    this.getLastWeekTransactions();
                    this.fetchAccountBalance();
                    this.getAccountIncompleteMessage();
                }
            },
            immediate: true,
            deep: true
        },
        accountSettings: {
            handler() {
                this.workoutTakenHeight();
                this.quickLanchSettingsEnabled();
            }
        },
        getAccountBalance: {
            handler(balance) {
                if (balance.pendingPayments.length > 0)
                    this.calcPP();

            }
        },
        drawer: function () {
            this.localdrawer = this.drawer;
        },
        localdrawer: function (newVal) {
            this.setDrawerOnLocalDrawerChange(newVal);
        },
    },
    methods: {
        ...mapActions([
            'paymentHasPoppedUp',
            'resetPaymentPopUp',
            'fetchAccountBalance'
        ]),

        async getLastWeekTransactions() {
            this.isLoadingTransactions = true;
            let now = new Date();
            let lastWeek = new Date();
            lastWeek.setDate(lastWeek.getDate() - 6);
            now.setDate(now.getDate() + 1);

            this.transactions = await restResourceService.getTransactions(lastWeek, now);
            this.isLoadingTransactions = false;
            this.getTodaysPay();
        },
        workoutTakenHeight() {
            if (this.accountSettings.quickLaunch)
                this.takenHeight = (parseInt(this.takenHeight) + 50).toString();

            // if (this.accountSettings.notifications)
            //     this.takenHeight = (parseInt(this.takenHeight) + 50).toString();
        },
        calcPP() {
            let total = 0;
            if (this.getAccountBalance.balance == null)
                return 0;
            if (this.getAccountBalance.pendingPayments.length < 1)
                return 0;

            this.getAccountBalance.pendingPayments.forEach(el => {
                total = total + el.amount;
            })
            this.pendingPaymentsTotal = total * -1;
        },
        getTodaysPay: function () {
            this.todayIncome = 0;
            if (this.transactions.length < 1)
                return;

            this.transactions.forEach(element => {
                let today = new Date();
                let date = new Date(element.transactionDate);
                //Only need to get the day bacause already got the week. 
                if (date.getDate() == today.getDate()) {
                    if (element.type == 'CHIP' || element.type == 'CHIP2')
                        this.todayIncome = this.todayIncome + Math.abs(element.amount);
                }
            })
            this.transactions.sort((a, b) => new Date(a.transactionDate) - new Date(b.transactionDate)); //Sorted list
            this.lastTransactionDate = this.formatDate(this.transactions[this.transactions.length - 1].transactionDate);
        },
        formatDate: function (datePassed) {
            let date = new Date(datePassed);
            let displayMonth = date.getMonth() + 1;
            let mins;
            if (date.getMinutes() < 10)
                mins = "0" + date.getMinutes();
            else
                mins = date.getMinutes();

            return date.getDate() + "/" + displayMonth + "/" + date.getFullYear() + " (" + date.getHours() + ":" + mins + ")";
        },
        setDrawerOnLocalDrawerChange: function (value) {
            this.$emit('drawer', value);
        },
        //Checks for valid payment details added, 
        //And for account status to be active
        getAccountIncompleteMessage: function () {
            if (this.getAccount.payeeId == '-1') {
                this.hasIncompleteAcc = true;
                this.noPaymentDetailsMessage = process.env.VUE_APP_NO_PAYMENTDETAILSMESSAGE;
            }
            if (this.getAccount.status != "ACTIVE") {
                this.hasIncompleteAcc = true;
                this.noVerificationMessage = process.env.VUE_APP_NO_VERIFICATIONMESSAGE;
            }
        },
        quickLanchSettingsEnabled() {
            this.isQuickLaunch = this.accountSettings.quickLaunch;
            this.quickLaunch = [];
            // let notificationLauncher = {
            //     icon: "mdi-bell",
            //     link: this.navNotifications
            // }
            let checkInLauncher = {
                icon: "mdi-airplane-check",
                link: this.navCheckIn
            }
            let TakePaymentLauncher = {
                icon: "mdi-barcode-scan",
                link: this.navTakePayment
            }

            //Remove from bottom draw
            // if (this.accountSettings.notifications) {
            //     this.isNotificationsEnabled = true;
            //     this.quickLaunch.push(notificationLauncher);
            // }

            if (this.accountSettings.checkIn)
                this.quickLaunch.push(checkInLauncher);

            if (this.accountSettings.takePayment)
                this.quickLaunch.push(TakePaymentLauncher);
        },
        openNoPayDialog: function () {
            this.$emit('openNoPaymentDialog', true);
        },
        closeVerificationDialog() {
            this.verificationDialog = false;
        },
        navTakePayment: function () {
            this.$router.push({ path: '/TakePayment' })
        },
        navNotifications: function () {
            this.$router.push({ path: '/notifications' })
        },
        navCheckIn: function () {
            this.$router.push({ path: '/checkIn' })
        },
    },
};
</script>


<style scoped>
.fixed_pos {
    position: fixed;
}

.grid-container {
    display: grid;
    gap: 6px 6px;
    grid-template-columns: 2fr 1fr;
    align-items: baseline;
    justify-content: space-between;
    align-content: center;
}

.myflexbox {
    display: flex;
}

.notifications {
    position: absolute;
    margin-left: 88%;

}

.counter {
    position: absolute;
    margin-right: -23px;
    margin-top: -22px;
    background-color: red;
    color: #fff;
    padding: 2px 6px;
    font-size: 11px;
    z-index: 2;
    -webkit-border-radius: 10rem;
    -moz-border-radius: 10rem;
    -ms-border-radius: 10rem;
    -o-border-radius: 10rem;
    border-radius: 10rem;
}

.alerts {
    margin: 6px;
    margin-bottom: 0px;
}
</style>